import React, { Fragment } from 'react';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import ordinal from '../../utils/ordinal';

const BaseSelector=({label,onChange,value,disabled,values,clearItem,ordinalValues})=>
	<Fragment>
		<InputLabel id="label">{label}</InputLabel>
		<Select labelId="label" label={label} onChange={(e)=>onChange(e.target.value)} autoWidth={true} style={{width:"100%"}} value={value} disabled={disabled}
				MenuProps={{disableScrollLock:true}}>
			{clearItem && <MenuItem key="none" value="">&lt;Clear&gt;</MenuItem>}
			{values.map((v,j)=><MenuItem key={j} value={v}>{ordinalValues?ordinal(v):v}</MenuItem>)}
		</Select>
	</Fragment>

const Selector=(props)=>{
	if (props.label)
		return <FormControl><BaseSelector {...props}/></FormControl>
	else
		return <BaseSelector {...props}/>
}

export default Selector;
